import PromiseMerger from '../promise-merger';
import { getGlobalConfig } from './utils';
const publicKeys = new WeakMap();
const privateKeys = new WeakMap();
export class AttachmentStore {
    constructor() {
        this.batchCallback = (uuids, args, items) => {
            return args[0](uuids, { isPublic: args[1], items });
        };
        this.merger = new PromiseMerger(this.batchCallback, { maxAge: 60000, max: 100 });
    }
    fetchCountInBatch(options, field) {
        const { batchFetchCount } = getGlobalConfig('attachment', field);
        if (batchFetchCount) {
            const { isPublic, attachmentUUID } = options;
            return this.merger.add(attachmentUUID, () => {
                if (isPublic) {
                    let publicKey = publicKeys.get(batchFetchCount);
                    if (!publicKey) {
                        publicKey = Symbol('PUBLIC_KEY');
                        publicKeys.set(batchFetchCount, publicKey);
                    }
                    return publicKey;
                }
                let privateKey = privateKeys.get(batchFetchCount);
                if (!privateKey) {
                    privateKey = Symbol('PRIVATE_KEY');
                    privateKeys.set(batchFetchCount, privateKey);
                }
                return privateKey;
            }, [batchFetchCount, isPublic], options);
        }
        return Promise.resolve(undefined);
    }
    /**
     * @deprecated
     */
    get(_uuid) {
        return undefined;
    }
    /**
     * @deprecated
     */
    set(_uuid, _cache) {
    }
    /**
     * @deprecated
     */
    getCount(_uuid) {
        return undefined;
    }
    /**
     * @deprecated
     */
    getAttachments(_uuid) {
        return undefined;
    }
    /**
     * @deprecated
     */
    clearCache(_codes) {
    }
}
export default new AttachmentStore();
